import { Link } from "react-router-dom";
import { useDocumentMeta } from "../lib/useDocumentMeta";
import { toDocumentMeta, getRouteMeta } from "../route-meta";
import { rolloutMode } from "../rollout";

export default function About() {
  useDocumentMeta(toDocumentMeta(getRouteMeta("/about", rolloutMode)!));
  return (
    <>
      <section className="mk-container pt-12 sm:pt-20 pb-8">
        <p className="mk-eyebrow">Jørgen Larsen · Copenhagen</p>
        <h1 className="mk-h1 mt-4 max-w-3xl">From LØBEMENTOR to PX7 Training.</h1>
        <p className="mk-lead mt-5 max-w-3xl">I'm Jørgen. Through LØBEMENTOR, I work with runners personally. I'm building PX7 Training so runners can get a training plan that adjusts after each run, with an optional written training review when you want my assessment.</p>
      </section>
      <section className="mk-container py-10">
        <div className="max-w-3xl mk-prose">
          <h2>Planning around everyday running.</h2>
          <p>A missed session, tired legs or a busy week can change what is useful to run next. PX7 Training adjusts the upcoming sessions to the training you completed and the time you have.</p>
          <p>Each session gives you a duration, instructions and an explanation of what it trains. You can record changes to the session and how it felt.</p>
          <h2>Coaching experience and research.</h2>
          <p>The questions I get through coaching help identify what runners need from the app. Research helps determine the rules for choosing sessions, setting targets and adjusting the plan.</p>
          <p>We keep improving the method and the app with new research and runners' results and feedback. The Science page explains how the research informs your training.</p>
          <h2>Built in Copenhagen.</h2>
          <p>PX7 Training is an English-language app for runners around the world. My contact with runners through LØBEMENTOR helps us test the method against the practical questions people bring to their training.</p>
          <h2>Software and personal guidance.</h2>
          <p>PX7 Training provides your digital training plan, with one-off written reviews available separately. For ongoing online coaching, detailed race preparation or individual appointments, work with me through <a href="https://lobementor.com">LØBEMENTOR</a>. Face-to-face sessions are available in Denmark, mainly around Copenhagen.</p>
          <p>The software is built by <a href="https://px7.digital">PX7 Digital</a>. You can reach me at <a href="mailto:jorgen@larsen.zone">jorgen@larsen.zone</a>.</p>
        </div>
      </section>
      <section className="mk-container py-12">
        <div className="flex flex-wrap gap-3">
          <Link to="/method" className="mk-button-ghost">Read the method →</Link>
          <Link to="/pricing" className="mk-button-accent">Access and pricing →</Link>
        </div>
      </section>
    </>
  );
}
